import "./logout.css";
import { useEffect } from "react";
import { useLogout } from "utils";

export const Logout = () => {
  const { notLogOutHandler, logOutHandler } = useLogout();

  return (
    <section className="logoutContainer">
      <div className="heading">
        <h1>
          <strong>LOG OUT</strong>
        </h1>
        <small>Oh no! You're leaving...</small>
      </div>

      <form className="logout" action="logout">
        <button
          className="cursor-pointer primary"
          onClick={() => notLogOutHandler()}
        >
          Just kidding
        </button>

        <button
        type="button"
          className="cursor-pointer secondary"
          onClick={() => logOutHandler()}
        >
          Log Me Out
        </button>
      </form>
    </section>
  );
};
